module.exports = __webpack_public_path__ + "img/build_home.3b37f68e.svg";